/** @format */

/** Login action-types **/
export const LOGIN_REQUESTED = 'LOGIN_REQUESTED';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const CLEAR_LOGIN_STATE = 'CLEAR_LOGIN_STATE';

/** Logout action-types **/
export const LOGOUT_REQUESTED = 'LOGOUT_REQUESTED';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILED = 'LOGOUT_FAILED';

export const ACTIVE_INDEX = 'ACTIVE_INDEX';
export const ACTIVE_INDEX_INFO_CENTER = 'ACTIVE_INDEX_INFO_CENTER';

export const SEND_FRILANCE_EMAIL_REQUESTED = 'SEND_FRILANCE_EMAIL';
export const SEND_FRILANCE_EMAIL_SUCCESS = 'SEND_FRILANCE_SUCCESS';
export const SEND_FRILANCE_EMAIL_ERROR = 'SEND_FRILANCE_EMAIL_ERROR';
export const RESET_EMAIL_REDUCER = 'RESET_EMAIL_REDUCER';

export const SAVE_USERNAME = 'SAVE_USERNAME';

export const NOTIFICATIONS_REQUESTED = 'NOTIFICATIONS_REQUESTED';
export const NOTIFICATIONS_SUCCESS = 'NOTIFICATIONS_SUCCESS';
export const NOTIFICATIONS_ERROR = 'NOTIFICATIONS_ERROR';

/** broker profile related actions  */

export const BROKER_PROFILE_REQUESTED = 'BROKER_PROFILE_REQUESTED';
export const BROKER_PROFILE_SUCCESS = 'BROKER_PROFILE_SUCCESS';
export const BROKER_PROFILE_ERROR = 'BROKER_PROFILE_ERROR';

export const BROKER_PROFILE_BY_SLUG_REQUESTED =
  'BROKER_PROFILE_BY_SLUG_REQUESTED';
export const BROKER_PROFILE_BY_SLUG_SUCCESS = 'BROKER_PROFILE_BY_SLUG_SUCCESS';
export const BROKER_PROFILE_BY_SLUG_ERROR = 'BROKER_PROFILE_BY_SLUG_ERROR';

export const BROKER_OBJECTS_REQUESTED = 'BROKER_OBJECTS_REQUESTED';
export const BROKER_OBJECTS_SUCCESS = 'BROKER_OBJECTS_SUCCESS';
export const BROKER_OBJECTS_ERROR = 'BROKER_OBJECTS_ERROR';

export const BROKER_OBJECTS_BY_SLUG_REQUESTED =
  'BROKER_OBJECTS_BY_SLUG_REQUESTED';
export const BROKER_OBJECTS_BY_SLUG_SUCCESS = 'BROKER_OBJECTS_BY_SLUG_SUCCESS';
export const BROKER_OBJECTS_BY_SLUG_ERROR = 'BROKER_OBJECTS_BY_SLUG_ERROR';

export const BROKER_OBJECT_REQUESTED = 'BROKER_OBJECT_REQUESTED';
export const BROKER_OBJECT_SUCCESS = 'BROKER_OBJECT_SUCCESS';
export const BROKER_OBJECT_ERROR = 'BROKER_OBJECT_ERROR';

export const MORE_BROKER_OBJECTS_REQUESTED = 'MORE_BROKER_OBJECTS_REQUESTED';
export const MORE_BROKER_OBJECTS_SUCCESS = 'MORE_BROKER_OBJECTS_SUCCESS';
export const MORE_BROKER_OBJECTS_ERROR = 'MORE_BROKER_OBJECTS_ERROR';

export const MORE_BROKER_OBJECTS_BY_SLUG_REQUESTED =
  'MORE_BROKER_OBJECTS_BY_SLUG_REQUESTED';
export const MORE_BROKER_OBJECTS_BY_SLUG_SUCCESS =
  'MORE_BROKER_OBJECTS_BY_SLUG_SUCCESS';
export const MORE_BROKER_OBJECTS_BY_SLUG_ERROR =
  'MORE_BROKER_OBJECTS_BY_SLUG_ERROR';

export const UPDATE_BROKER_REQUESTED = 'UPDATE_BROKER_REQUESTED';
export const UPDATE_BROKER_SUCCESS = 'UPDATE_BROKER_SUCCESS';
export const UPDATE_BROKER_ERROR = 'UPDATE_BROKER_ERROR';
